(function(){
  var DEBUG = false;
  function log(){ if(DEBUG) console.log.apply(console, ['[AvisUnisign]'].concat([].slice.call(arguments))); }

  function scrapeReputon(){
    var widget = document.querySelector('.reputon-etsy-reviews-widget');
    if(!widget) return null;
    var cards = widget.querySelectorAll('.reputon-card');
    if(!cards.length) return null;
    var out = [];
    for(var i=0; i<cards.length; i++){
      var c = cards[i];
      // Skip AI summary card
      if(c.classList.contains('reputon-Summary')) continue;
      var name = (c.querySelector('.reputon-name') || {}).textContent || '';
      name = name.trim();
      var date = (c.querySelector('.reputon-date') || {}).textContent || '';
      date = date.trim();
      var text = (c.querySelector('.reputon-text') || {}).textContent || '';
      text = text.trim();
      var verified = !!c.querySelector('.reputon-verified');
      // Image - prefer review image, fallback to product image
      var imgEl = c.querySelector('.reputon-reviews-image') || c.querySelector('.reputon-product-image img') || c.querySelector('.reputon-product-image');
      var img = imgEl ? (imgEl.src || imgEl.getAttribute('src') || '') : '';
      // Avatar
      var avatarEl = c.querySelector('.reputon-avatar img');
      var avatarImg = avatarEl ? avatarEl.src : '';
      var initials = avatarImg ? '' : (name ? name.charAt(0).toUpperCase() : '?');
      // Stars - count SVGs in rating container
      var starsCont = c.querySelector('.reputon-rating-stars');
      var stars = 5;
      if(starsCont){
        var svgs = starsCont.querySelectorAll('svg');
        if(svgs.length > 0 && svgs.length <= 5) stars = svgs.length;
      }
      if(name && text){
        out.push({ name: name, date: date, text: text, verified: verified, img: img, avatarImg: avatarImg, initials: initials, stars: stars });
      }
    }
    return out;
  }

  function hideReputon(){
    var widget = document.querySelector('.reputon-etsy-reviews-widget');
    if(!widget) return;
    var wrapper = widget.closest('.shopify-app-block') || widget.closest('.shopify-section') || widget.parentElement;
    if(wrapper){
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.style.cssText = 'position:absolute!important;left:-9999px!important;top:0!important;width:1px!important;height:1px!important;overflow:hidden!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important;';
    }
  }

  function escapeHtml(s){
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function starsString(n){
    n = parseInt(n, 10) || 5;
    var out = '';
    for(var i=0; i<n; i++) out += '★';
    for(var j=0; j<Math.max(0, 5-n); j++) out += '☆';
    return out;
  }

  function initSection(root){
    if(!root || root.dataset.auInit === '1') return;
    root.dataset.auInit = '1';

    var grid = root.querySelector('[data-au-grid]');
    var modal = root.querySelector('[data-au-modal]');
    if(!grid || !modal) return;

    var reviews = [];
    var idx = 0;

    function q(sel){ return modal.querySelector(sel); }
    function setText(sel, txt){ var el = q(sel); if(el) el.textContent = txt || ''; }
    function setAttr(sel, attr, val){ var el = q(sel); if(el) el.setAttribute(attr, val); }

    function renderModal(){
      var d = reviews[idx]; if(!d) return;
      var imgWrap = q('.au-modal-image');
      var img = q('[data-au-modal-img]');
      if(img && imgWrap){
        if(d.img){ img.src = d.img; img.alt = 'Avis ' + d.name; imgWrap.style.display = ''; }
        else { imgWrap.style.display = 'none'; }
      }
      // Avatar
      var avatarEl = q('[data-au-modal-avatar]');
      if(avatarEl){
        if(d.avatarImg){
          avatarEl.style.backgroundImage = 'url(' + d.avatarImg + ')';
          avatarEl.style.backgroundSize = 'cover';
          avatarEl.style.backgroundPosition = 'center';
          avatarEl.textContent = '';
        } else {
          avatarEl.style.backgroundImage = '';
          avatarEl.textContent = d.initials || '';
        }
      }
      setText('[data-au-modal-name]', d.name);
      setText('[data-au-modal-date]', d.date);
      setText('[data-au-modal-rating]', starsString(d.stars));
      setText('[data-au-modal-text]', d.text);
      var badge = q('[data-au-modal-badge]');
      if(badge) badge.style.display = d.verified ? '' : 'none';
      var counter = q('[data-au-modal-counter]');
      if(counter) counter.innerHTML = '<strong>' + (idx + 1) + '</strong> / ' + reviews.length;

      var prevI = (idx - 1 + reviews.length) % reviews.length;
      var nextI = (idx + 1) % reviews.length;
      var p = reviews[prevI], n = reviews[nextI];
      // Peeks
      function setPeek(side, data){
        var av = q('[data-au-peek-avatar="'+side+'"]');
        if(av){
          if(data.avatarImg){
            av.style.backgroundImage = 'url(' + data.avatarImg + ')';
            av.style.backgroundSize = 'cover';
            av.style.backgroundPosition = 'center';
            av.textContent = '';
          } else {
            av.style.backgroundImage = '';
            av.textContent = data.initials || '';
          }
        }
        setText('[data-au-peek-name="'+side+'"]', data.name);
        setText('[data-au-peek-stars="'+side+'"]', starsString(data.stars));
        setText('[data-au-peek-preview="'+side+'"]', data.text);
      }
      setPeek('prev', p);
      setPeek('next', n);

      var card = q('[data-au-modal-card]');
      if(card) card.scrollTop = 0;
    }

    function openAt(i){ idx = i; renderModal(); modal.classList.add('is-open'); document.body.classList.add('au-modal-open'); }
    function navigate(d){ idx = (idx + d + reviews.length) % reviews.length; renderModal(); }
    function closeModal(){ modal.classList.remove('is-open'); document.body.classList.remove('au-modal-open'); }

    // Modal handlers (one-time)
    var closeBtn = q('[data-au-modal-close]'); if(closeBtn) closeBtn.addEventListener('click', closeModal);
    var navPrev = q('[data-au-nav="prev"]'); if(navPrev) navPrev.addEventListener('click', function(){ navigate(-1); });
    var navNext = q('[data-au-nav="next"]'); if(navNext) navNext.addEventListener('click', function(){ navigate(1); });
    var peekPrev = q('[data-au-peek="prev"]'); if(peekPrev) peekPrev.addEventListener('click', function(){ navigate(-1); });
    var peekNext = q('[data-au-peek="next"]'); if(peekNext) peekNext.addEventListener('click', function(){ navigate(1); });
    modal.addEventListener('click', function(e){
      if(e.target.closest('.au-modal-card') || e.target.closest('.au-peek') || e.target.closest('.au-modal-nav')) return;
      closeModal();
    });
    document.addEventListener('keydown', function(e){
      if(!modal.classList.contains('is-open')) return;
      if(e.key === 'Escape') closeModal();
      if(e.key === 'ArrowLeft') navigate(-1);
      if(e.key === 'ArrowRight') navigate(1);
    });

    function buildCards(){
      var data = scrapeReputon();
      if(!data || data.length === 0) return false;
      reviews = data;
      hideReputon();
      grid.innerHTML = '';
      var visibleCount = Math.min(parseInt(grid.dataset.visible || '3', 10) || 3, reviews.length);
      for(var i=0; i<visibleCount; i++){
        (function(i){
          var r = reviews[i];
          var card = document.createElement('article');
          card.className = 'au-card';
          var imgHTML = '';
          if(r.img){
            imgHTML = '<div class="au-card-image"><img src="' + escapeHtml(r.img) + '" alt="Avis ' + escapeHtml(r.name) + '" loading="lazy"></div>';
          }
          var avatarHTML;
          if(r.avatarImg){
            avatarHTML = '<div class="au-avatar" style="background-image:url(' + escapeHtml(r.avatarImg) + ');background-size:cover;background-position:center;color:transparent;"></div>';
          } else {
            avatarHTML = '<div class="au-avatar">' + escapeHtml(r.initials) + '</div>';
          }
          var badgeHTML = r.verified ? '<span class="au-reviewer-badge">Vérifié</span>' : '';
          var rating = starsString(r.stars);
          card.innerHTML = imgHTML +
            '<div class="au-card-body">' +
              '<div class="au-card-meta">' +
                avatarHTML +
                '<div class="au-reviewer-info">' +
                  '<div class="au-reviewer-name">' + escapeHtml(r.name) + badgeHTML + '</div>' +
                  '<div class="au-card-date">' + escapeHtml(r.date) + '</div>' +
                '</div>' +
              '</div>' +
              '<div class="au-card-rating">' + rating + '</div>' +
              '<p class="au-card-text">' + escapeHtml(r.text) + '</p>' +
            '</div>';
          card.addEventListener('click', function(){ openAt(i); });
          grid.appendChild(card);
        })(i);
      }
      log('Built', visibleCount, 'cards from', reviews.length, 'reviews');
      return true;
    }

    var attempts = 0;
    var maxAttempts = 30; // 30 * 500ms = 15s
    function tryBuild(){
      attempts++;
      if(buildCards()) return;
      if(attempts < maxAttempts) setTimeout(tryBuild, 500);
      else log('Gave up waiting for Reputon after', attempts, 'attempts');
    }
    // Start trying after a small delay
    setTimeout(tryBuild, 800);

    // Also watch DOM for late-loaded reputon cards
    if(window.MutationObserver){
      var observer = new MutationObserver(function(){
        if(grid.children.length === 0){
          if(buildCards()){ observer.disconnect(); }
        } else {
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function(){ observer.disconnect(); }, 16000);
    }
  }

  function initAll(){
    document.querySelectorAll('[data-avis-unisign]').forEach(initSection);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
